export const PageDataState = {
    Searchs: {
        type_a_student_profile_id: {
            type: 'text',
            id: 'type_a_student_profile_id',
            label: 'โปรไฟล์นักศึกษา',
            value: '',
            placeholder: 'โปรไฟล์นักศึกษา'
        }
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primary',
                required: false
            },
            error: { status: null, msg: '' }
        },
        type_a_student_profile_id: {
            type: 'text',
            id: 'type_a_student_profile_id',
            label: 'รหัสโปรไฟล์นักศึกษา',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        welfare_id: {
            type: 'select',
            id: 'welfare_id',
            label: 'สวัสดิการ',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        description: {
            type: 'text',
            id: 'description',
            label: 'โปรดระบุ',
            value: '',
            validator: {
                type: 'text',
                required: false,
                minLength: 5,
                maxLength: 4096
            },
            error: { status: null, msg: ''}
        },
        support_time: {
            type: 'select',
            id: 'support_time',
            label: 'ระยะเลาที่ได้รับสวัสดิการ',
            value: '',
            validator: {
                type: 'text',
                required: true,
            },
            error: { status: null, msg: '' }
        },        

    },
    InputGroup: {}
}